import React, { useState } from "react";
import { createOrderId, verifyPayment } from "../../services/payments";
import { CTAButton, GSTText } from "./internship.components";
import Logo from "../../images/logo.png";
import { useCookies } from "react-cookie";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    document.body.appendChild(script);
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
  });
}

function PaymentPage({ data, enrollFunction, verifySession }) {
  const [cookies] = useCookies();
  var [orderId, setOrderId] = useState();
  const price = Number(data.price) * 100;

  const handlePay = async () => {
    const isSessionActive = await verifySession();
    if (!isSessionActive) return;

    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    await createOrderId({ amount: price, internshipID: "internship-id-101" })
      .then((response) => {
        if (response.status === 200) {
          orderId = response.data.orderID;
          setOrderId(orderId);
          checkoutOrder();
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <div>
      {/* <CommonLoginDialog open={open} setOpen={setOpen} /> */}
      <CTAButton
        onClick={handlePay}
        sx={{
          top:
            data.type === "intermediate" ? { xs: "25px", md: "72px" } : "22px",
        }}
      >
        ₹{data.price} <GSTText>+GST</GSTText>
      </CTAButton>
    </div>
  );

  async function checkoutOrder() {
    const KEY_ID = "rzp_test_lsmoxwdlbOSoB3";
    var options = {
      key: KEY_ID,
      amount: price,
      currency: "INR",
      name: "XPVERSE",
      description: "Learn while you Implement",
      image: Logo,
      order_id: orderId,
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        // alert(response.razorpay_order_id);
        // alert(response.razorpay_signature);

        paymentVerification(response);
      },
      prefill: {
        name: `${cookies.firstName} ${cookies.lastName}`,
        email: cookies.emailID,
      },
      theme: {
        color: "#229fa4",
      },
    };

    var rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      // alert(response.error.code);
      alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
    });

    rzp1.open();
  }

  async function paymentVerification(razorpayResponse) {
    await verifyPayment(razorpayResponse)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.signatureIsValid)
            enrollFunction(razorpayResponse.razorpay_order_id);
          else alert("payment received is not from an authentic source");
        }
      })
      .catch((error) => console.log(error));
  }
}

export default PaymentPage;
